export default __webpack_public_path__ + "static/truck-accident-f387afbb48415fdf7e7f7bf8ecf012df.jpg";